module.exports = __webpack_public_path__ + "img/m-oth.4b8728d3.webp";